import clsx from 'clsx';
import { FunctionComponent } from 'react';
import Check from './Check';
import { Price } from './types';

export const HEIGHT_CHECK_CLASSNAME = 'height-check';

type PriceCardProps = {
  className?: string;
  price: Price;
};

const PriceCard: FunctionComponent<PriceCardProps> = ({ className, price }) => {
  const { product } = price;

  let ctaProps: JSX.IntrinsicElements['a'];
  if (price.custom_cta) {
    ctaProps = {
      href: '/sales', // TODO(pricing-table) - generate URL?
      onClick: undefined,
      children: 'Contact us',
    };
  } else {
    const lookup_key = price.lookup_key || price.id;
    ctaProps = {
      href: `/checkout?price=${encodeURIComponent(lookup_key)}`,
      onClick: undefined, // (evt) => { evt.preventDefault(); },
      children: price.lookup_key ? 'Subscribe' : 'Missing `lookup_key`',
    };
  }

  return (
    <div className={clsx('bg-white px-8 py-6 text-left', className)}>
      <div className="mb-6 lg:min-h-[var(--height-check)]">
        <div className={HEIGHT_CHECK_CLASSNAME}>
          <div className="text-lg font-semibold">{product.name}</div>
          {product.description ? (
            <div className="text-sm leading-tight text-gray-400">
              {product.description}
            </div>
          ) : null}
          {!price.custom_cta && (
            <div className="mt-8 flex gap-2">
              <span className="text-4xl font-bold">
                {formatAmount({
                  amount: price.unit_amount,
                  currency: price.currency,
                })}
              </span>
              {Boolean(price.recurring) && (
                <span className="text-sm font-normal leading-tight text-gray-400">
                  per
                  <br />
                  {price.recurring.interval}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="mb-6">
        <a
          {...ctaProps}
          className="block w-full rounded-md bg-green-300 px-6 py-3 text-center text-green-900 hover:bg-green-400 hover:text-green-900"
        />
      </div>
      {product.marketing_features?.length ? (
        <div className="text-sm leading-tight">
          <div className="">This includes:</div>
          <ul>
            {product.marketing_features.map((feat, i) => (
              <li key={i} className="mb-4 flex gap-4">
                <Check className="mt-[3px] h-3 w-3 shrink-0 grow-0" />
                <div className="grow">{feat.name}</div>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

PriceCard.displayName = 'PriceCard';

export default PriceCard;

// ##

const formatAmount = ({
  amount,
  currency,
}: {
  amount: number;
  currency: string;
}) => {
  const dollars = amount / 100;
  return dollars.toLocaleString(undefined, {
    style: 'currency',
    currency: currency || 'USD',
  });
};
